import React, { Component, PropTypes } from 'react';
import { HoverColor } from '../../../widgets/index';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';
import HeroImage from '../../../ngbe_base/hero-image/hero-image';
import Style from 'style-it';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

class HeaderPreview extends Component {
    render() {
        const fontSize = new CSSLength(this.props.userBar.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        return (
            <div className="HeaderPreview">
                <HoverColor
                    color={this.props.userBar.color.hover}
                    secondaryColor={this.props.userBar.iconColor.hover}
                    textDecoration={this.props.userBar.textDecoration.hover}
                />
                <div
                    className="row header-bar-preview"
                    style={{
                        fontFamily: this.props.userBar.font,
                        textAlign: 'center',
                        // lineHeight: this.props.preview.primaryText.lineHeight,
                        textDecoration: this.props.userBar.textDecoration.normal,
                        textTransform: this.props.userBar.textTransform,
                        // fontStyle: this.props.preview.primaryText.style,
                        color: this.props.userBar.color.normal,
                        fontWeight: this.props.userBar.fontWeight,
                        fontSize: fontSize3,
                        background: this.props.userBar.background
                    }}
                >
                    <div className="col-xs-1  active-hover">Rooms</div>
                    <div className="col-xs-1 active-hover">Add-Ons</div>
                    <div className="col-xs-2 active-hover">Reservations</div>
                    <div className="col-xs-2">
                        <span
                            className="spark-icon-phone spark-icon--md active-hover-secondary"
                            style={{ color: this.props.userBar.iconColor.normal }}
                        >
                            {' '}
                        </span>
                        <span className=" active-hover">555-555-5555</span>
                    </div>
                    <div className="col-xs-2">
                        <span
                            className="spark-icon-world spark-icon--md active-hover-secondary"
                            style={{ color: this.props.userBar.iconColor.normal }}
                        >
                            {' '}
                        </span>{' '}
                        <span className=" active-hover">English - US</span>
                    </div>
                    <div className="col-xs-2">
                        <span
                            className="spark-icon-currency-convert spark-icon--md active-hover-secondary"
                            style={{ color: this.props.userBar.iconColor.normal }}
                        >
                            {' '}
                        </span>{' '}
                        <span className=" active-hover">USD - US Dollars</span>
                    </div>
                    <div className="col-xs-1">
                        <span
                            className="spark-icon-user spark-icon--md active-hover-secondary"
                            style={{ color: this.props.userBar.iconColor.normal }}
                        >
                            {' '}
                        </span>
                        <span className=" active-hover">SIGN IN</span>
                    </div>
                </div>
                {this.props.heroImage.background && this.props.heroImage.background !== ('url()' || '') && (
                    <HeroImage />
                )}
            </div>
        );
    }
}

HeaderPreview.propTypes = {
    children: PropTypes.element,
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

const mapHeaderPreviewStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.header, ...state.theme.header };
};

export default connect(mapHeaderPreviewStateToProps)(HeaderPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/Preview.js